var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 85.333,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 341.337
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "288,85.33 224,85.33 224,223.996 0,223.996 0,287.996 224,287.996 224,426.662 288,426.662  288,287.996 512,287.996 512,223.996 288,223.996 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "393.785,315.358 512,381.034 512,315.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "458.634,426.662 311.652,344.998 311.652,426.662  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "90.341,315.356 0,365.546 0,315.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "200.348,329.51 200.348,426.661 25.491,426.661  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "143.693,315.358 0,395.188 0,426.662 0,426.662 200.348,315.358 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "118.215,196.634 0,130.958 0,196.634  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "53.366,85.33 200.348,166.994 200.348,85.33  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "421.659,196.636 512,146.446 512,196.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "311.652,182.482 311.652,85.331 486.509,85.331  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "368.307,196.634 512,116.804 512,85.33 512,85.33 311.652,196.634 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.4839cec4896b3141f334c06fe07d863c.svg";
export { ForwardRef as ReactComponent };